angular.module('unergie.main')
.filter('phone', () =>
    function (val) {
        if (val) {
            if (val.slice(0, 3) === '+33') {
                return `${val.slice(0, 3)} ${val.slice(3, 4)} ${val.slice(4, 6)} ${val.slice(6, 8)} ${val.slice(8, 10)} ${val.slice(10)}`
            } else if ((val.length === 10) && (val.slice(0, 1) === '0')) {
                return `+33 ${val.slice(1, 2)} ${val.slice(2, 4)} ${val.slice(4, 6)} ${val.slice(6, 8)} ${val.slice(8)}`
            } else if (val.slice(0, 1) === '+') {
                return `${val.slice(0, 3)} ${val.slice(3, 4)} ${val.slice(4, 6)} ${val.slice(6, 8)} ${val.slice(8, 10)} ${val.slice(10)}`
            }
            return `${val.slice(0, 2)} ${val.slice(2, 4)} ${val.slice(4, 6)} ${val.slice(6, 8)} ${val.slice(8)}`
        }
    },
)
